<template>
  <div>
    <b-form-group
      :class="{'error-input' : $v.dataBoard.name.$error}">
      <label> Board Name <span
        style="color:red" >*</span></label>
      <j-input
        v-model="$v.dataBoard.name.$model"
        placeholder="This is board name"/>
    </b-form-group>

    <b-form-group
      :class="{'error-input' : $v.dataBoard.description.$error}">
      <label> Description</label>
      <j-textarea
        v-model="$v.dataBoard.description.$model"
        placeholder="This is description"/>
    </b-form-group>

    <div
      v-if="mode === 'update'"
      class="card-field-container">
      <j-form-master
        ref="jFormMasterData"
        :list-field = "listField"/>
    </div>
    <br>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    mode: {
      type: String,
      default: 'create',
    },
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      listField: [],
      dataBoard: {
        name: '',
        description: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board', 'form_detail']),
  },
  watch: {
    form_detail(data) {
      this.dataBoard.name = data.name;
      this.dataBoard.description = data.description;
      this.listField = data.additional_info;
      this.listField.forEach((e) => {
        // eslint-disable-next-line
        e.is_backdate = e.is_back_date;
        const isGroup = e.groups ? e.groups : [];
        isGroup.forEach((i) => {
          // eslint-disable-next-line
          i.is_backdate = i.is_back_date;
        });
      });
    },
  },
  created() {
    this.listField = [];
    if (this.mode === 'update') {
      const params = {
        additional_info_block: {
          id: this.board.input_value,
        },
      };
      this.detailForm(params);
    }
  },
  methods: {
    ...mapActions('jStoreBoard', ['createForm', 'updateForm', 'detailForm']),
    clearFormData() {
      this.dataBoard = {
        name: '',
        description: '',
      };
      this.listField = [];
      this.$v.dataBoard.$reset();
    },
    validateForm() {
      this.$v.dataBoard.$touch();
      if (!this.$v.dataBoard.$error) {
        if (this.mode === 'update') {
          this.$refs.jFormMasterData.getData().then((data) => {
            const params = this.getParamsFormData(data);
            const paramsUpdate = {
              form: params,
              board: this.board.id,
            };
            this.$emit('getData', paramsUpdate);
            return true;
          });
        } else if (this.mode === 'create') {
          const params = this.getParamsFormData([]);
          this.$emit('getData', params);
          return true;
        }
      } else {
        this.$emit('getData', null);
        return false;
      }
      return false;
    },
    getParamsFormData(data) {
      const params = {
        id: this.mode === 'update' ? this.board.input_value : 0,
        name: this.dataBoard.name,
        description: this.dataBoard.description,
        additional_info: data,
        is_delete: false,
        smart_connect: {
          id: 0,
          is_use_category: false,
          is_use_amount: false,
          product_types: [],
        },
      };
      return params;
    },
  },
  validations() {
    return {
      dataBoard: {
        name: { required },
        description: { },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
  .card-field-container {
    border: 1px solid #ececec;
    padding: 15px;
    padding-bottom: 5px;
    font-size: 12px;
    background-color: whitesmoke;
  }
</style>



// WEBPACK FOOTER //
// src/views/board/form/jBoardForm.vue